import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { FiscalDeviceSetDefaultCommand, FiscalDeviceSetDefaultCommandHandlerBase, FiscalDeviceSetDefaultResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(FiscalDeviceSetDefaultCommand)
@Injectable({ providedIn: 'root'})
export class FiscalDeviceSetDefaultCommandHandler {
    private commandHandler: FiscalDeviceSetDefaultCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new FiscalDeviceSetDefaultCommandHandlerBase(http);
    }

    public async handleAsync(cmd: FiscalDeviceSetDefaultCommand): Promise<FiscalDeviceSetDefaultResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
